<form *ngIf="!!creditCardNumberform" [formGroup]="creditCardNumberform">
  <div class="va-inp-cc">
    <div class="input-cc-content">
      <ds-input-label class="cc-text">
        {{ creditCardNumberFormData.creditCardInputLabel }}</ds-input-label
      >
      <div>
        <iframe
          #semafoneIframe
          id="semafone-Iframe"
          class="sema-iframe"
          [attr.cobrowse]="false"
          [attr.transparency]="true"
          title=""
        >
        </iframe>
        <div *ngIf="creditCardType" class="card-icon">
          <img alt="logo" src="{{ creditCardType.imagePath }}" />
        </div>
      </div>
    </div>
  </div>
  <ds-error
    *ngIf="showError"
    [errorMessage]="creditCardNumberFormData.creditCardErrorMessage"
  >
  </ds-error>
</form>
